export { default as ProductMerchCard } from './ProductMerchCard';
